import { createAction, props } from '@ngrx/store';
import * as ActionConfigurationManager from './config.actions';



export const s3UploadDocuments = ActionConfigurationManager.S3_UPLOAD_DOCUMENTS;
export const s3UploadSuccess = ActionConfigurationManager.S3_UPLOAD_SUCCESS;
export const s3UploadFailure = ActionConfigurationManager.S3_UPLOAD_FAILURE;
